/* src/app/components/deinstag-modal/deinstag-modal.component.css */
.deinstag-modal-root {
  padding: 20px;
  color: white;
  overflow: auto;
}
h1 {
  text-align: center;
  background: black;
  color: white;
}
h2 {
  text-align: center;
  background: black;
  color: white;
}
p {
  margin: 20px 0;
}
.confirm-button {
  color: black;
  --background: cyan;
}
.decline-button {
  color: cyan;
  --background: black;
}
/*# sourceMappingURL=deinstag-modal.component.css.map */
